// @flow
import * as React from "react";
import styled, { css } from "styled-components";
import { rgba } from "polished";

const Wrapper = styled.div`
  position: absolute;
  top: -2px;
  left: 4px;
  transform: translateX(0.5px);
  height: 0;
  width: 0;

  ${props =>
    props.mobile &&
    css`
      top: 1px;
      left: 2px;
      transform: translateX(0);
    `};
`;

const NegativeContainer = styled.div`
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
  margin-left: -1px;
  padding: 4px 6px;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "12px"};
  line-height: 1;
  white-space: nowrap;
  color: rgba(255, 255, 2555, .7);
  box-shadow: 0px 0px 1px 0px ${props => props.theme.main};
  border-radius: 3px;
  background: rgba(230, 76, 60, .7);
  z-index: 2;

  :before {
    content: "";
    position: absolute;
    left: 50%;
    top: -6px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-bottom-color: rgba(230, 76, 60, .7);
    border-top: none;
  }

  ${props =>
    props.mobile &&
    css`
      top: 7px;
      font-size: ${({ theme }) =>
        theme.locale === "ar" ? theme.minFontSize : "10px"};
      border-radius: 2px;

      :before {
        top: -4px;
        border-width: 4px;
      }
    `};
`;

const PositiveContainer = styled.div`
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
  margin-left: -1px;
  padding: 4px 6px;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "12px"};
  line-height: 1;
  white-space: nowrap;
  color: rgba(255, 255, 255, .7);
  box-shadow: 0px 0px 1px 0px ${props => props.theme.main};
  border-radius: 3px;
  background: ${({ theme }) => rgba(theme.upper, .7)};
  z-index: 2;

  :before {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -6px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-top-color: ${({ theme }) => rgba(theme.upper, .7)};
    border-bottom: none;
  }

  ${props =>
    props.mobile &&
    css`
      font-size: ${({ theme }) =>
        theme.locale === "ar" ? theme.minFontSize : "10px"};
      border-radius: 2px;

      :before {
        bottom: -4px;
        border-width: 4px;
      }
    `};
`;

type Props = {
  isPositive: boolean,
  mobile?: boolean,
  children: React.Node
};

function Tooltip({ children, mobile, isPositive }: Props) {
  const Container = isPositive ? PositiveContainer : NegativeContainer;
  return (
    <Wrapper mobile={mobile}>
      <Container isPositive={isPositive} mobile={mobile}>
        {children}
      </Container>
    </Wrapper>
  );
}

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Chart/Tooltip/NextGenTooltip.js